// ** React Imports
import { Fragment, useState, useRef, useEffect } from "react"
import { useNavigate } from "react-router-dom"
// ** Third Party Components
import classnames from "classnames"
import PerfectScrollbar from "react-perfect-scrollbar"
import { NavItem, NavLink, Button } from "reactstrap"
// ** Third Party Components
import { X } from "react-feather"
import {
  handleMenuCollapsed
} from "../../../../../redux/layout"
import { displayMenu } from "../../../../../../src/views/redux/store"
import { useDispatch, useSelector } from "react-redux"
// ** Vertical Menu Components
import VerticalMenuHeader from "./VerticalMenuHeader"
import VerticalNavMenuItems from "./VerticalNavMenuItems"
import GlobalVariable from "../../../../../settings/global"
const headerText = GlobalVariable.headerText
import themeConfig from "../../../../../configs/themeConfig"

const trueBool = true
const Sidebar = (props) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  // ** Props
  const { menuCollapsed, menu, skin, menuData } = props

  // ** States
  const [groupOpen, setGroupOpen] = useState([])
  const [groupActive, setGroupActive] = useState([])
  const [currentActiveGroup, setCurrentActiveGroup] = useState([])
  const [activeItem, setActiveItem] = useState(null)

  const stores = useSelector((state) => state.commonreducerSlice)
  // ** Menu Hover State
  const [menuHover, setMenuHover] = useState(false)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  //const [displayMenu, setDisplayMenu] = useState(false)
  const handleWindowWidth = () => {
    setWindowWidth(window.innerWidth)
  }
  useEffect(() => {
    if (window !== undefined) {
      window.addEventListener("resize", handleWindowWidth)
    }
  }, [windowWidth])
  // ** Ref
  const shadowRef = useRef(null)

  // ** Function to handle Mouse Enter
  const onMouseEnter = () => {
    setMenuHover(true)
  }

  // ** Scroll Menu
  const scrollMenu = (container) => {
    if (shadowRef && container.scrollTop > 0) {
      if (!shadowRef.current.classList.contains("d-block")) {
        shadowRef.current.classList.add("d-block")
      }
    } else {
      if (shadowRef.current.classList.contains("d-block")) {
        shadowRef.current.classList.remove("d-block")
      }
    }
  }
  async function displayFunction() {
    await dispatch(displayMenu(!stores?.displayMenuBool))
  }
  const navigateMainPage = () => {
    sessionStorage.setItem('pageTransition', 'LR')
    navigate('/dashboard')
  }
  return (
    <div
      className={classnames(
        "main-menu menu-fixed menu-accordion menu-shadow",
        {
          expanded: menuHover || menuCollapsed === false,
          "menu-light": skin !== "semi-dark" && skin !== "dark",
          "menu-dark": skin === "semi-dark" || skin === "dark"
        }
      )}
      onMouseEnter={onMouseEnter}
      onMouseLeave={() => setMenuHover(false)}
      style={{ width: (menuCollapsed) ? '257px' : '257px', background: 'none', boxShadow: '3px 6px 9px #00000042', marginTop: windowWidth <= 1200 && stores?.displayMenuBool ? "0px" : "0px" }}
    // top: headerText ? '78px' : '64px',
    >
      {menu ? (
        menu({ ...props })
      ) : (
        <Fragment>
          {/* Vertical Menu Header */}
          <VerticalMenuHeader
            setGroupOpen={setGroupOpen}
            menuHover={menuHover}
            {...props}
          />
          {/* Vertical Menu Header Shadow */}
          <div className="shadow-bottom" ref={shadowRef}></div>
          {/* Perfect Scrollbar */}
          <PerfectScrollbar
            className="main-menu-content transitionProperty"
            options={{ wheelPropagation: false }}
            onScrollY={(container) => scrollMenu(container)}
            style={{ background: '#fff' }}
          >
            {windowWidth > 1200 && <ul className="nav navbar-nav text-center menuVisible_main" >
              <li className="nav-item">
                <NavLink
                  onClick={() => { }
                    // navigateMainPage()
                  }
                  className=""
                  style={{ cursor: "unset" }}
                >
                  <span className="brand-logo">
                    <img src={themeConfig.app.appLogoImage} alt="logo" className="sea_logo_header" />
                  </span>
                </NavLink>
              </li>
            </ul>}
            <ul className="navigation navigation-main">
              {
                windowWidth <= 1200 &&
                <li className="nav-item d-flex">
                  <NavLink
                    onClick={() => { }
                      // navigateMainPage()
                    }
                    className="mobileMenu"
                    style={{ cursor: "unset" }}
                  >
                    <span className="brand-logo">
                      <img src={themeConfig.app.appLogoImage} alt="logo" className="sea_logo_header" />
                    </span>
                  </NavLink>
                  <NavLink
                    className={menuCollapsed ? "nav-menu-main menu-toggle  hidden-xs is-active" : "nav-menu-main menu-toggle hidden-xs is-active p-0"}
                    style={{
                      top: headerText ? '22px' : '10px', display: windowWidth <= 1200 ? "unset" : "none", marginTop: "31px", marginLeft: "3px"
                    }}
                    onClick={() => {
                      // setMenuVisibility(true)
                      displayFunction()
                      dispatch(handleMenuCollapsed(menuCollapsed ? false : trueBool))
                    }}
                  >
                    <X className="ficon" size={30} />
                  </NavLink>
                </li>
              }

              <NavItem className="mobile-menu me-auto menu_visible " style={{ marginBottom: '0.8rem' }}>
                {/* <NavItem className="mobile-menu me-auto cancelmenu"> */}

                {/* </NavItem> */}
              </NavItem>
              <VerticalNavMenuItems
                items={menuData}
                menuData={menuData}
                menuHover={menuHover}
                groupOpen={groupOpen}
                activeItem={activeItem}
                groupActive={groupActive}
                setGroupOpen={setGroupOpen}
                menuCollapsed={menuCollapsed}
                setActiveItem={setActiveItem}
                setGroupActive={setGroupActive}
                currentActiveGroup={currentActiveGroup}
                setCurrentActiveGroup={setCurrentActiveGroup}
              />
            </ul>
          </PerfectScrollbar>
        </Fragment>
      )}
    </div>
  )
}

export default Sidebar
